// @flow
import * as colors from './colors'
import * as constants from '../er2_ui/styles/constants'

export const rawStyles = {
    mapToolbarPanel: {
        alignItems: 'stretch',
        backgroundColor: colors.white,
        borderLeft: '1px solid grey',
        display: 'flex',
        flexDirection: 'column',
        gridColumnStart: 'toolbarPanel',
        gridColumnEnd: 'toolbar',
        gridRowStart: 'subHeader',
        gridRowEnd: 'bottom',
        overflowY: 'auto',
        zIndex: constants.aboveLeafletMap,
    },
    mapToolbarPanelScroll: {
        height: 'calc(100% - 44px)',
        overflowY: 'auto',
    },
}

export default rawStyles
